<template>
  <button class="btn" :class="{'btn_align-left': left, 'btn_align-right': right, 'btn_red': red, 'btn_white': white, 'btn_large': large}" :disabled="disabled" v-on="$listeners">
    <slot></slot><slot name="icon"></slot><!-- TODO add disabled color for icon in btn -->
  </button>
</template>

<script>
export default {
  props: {
    left: {
      type: Boolean,
    },
    right: {
      type: Boolean,
    },
    white: {
      type: Boolean,
    },
    red: {
      type: Boolean,
    },
    large: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
.btn {
  @include removeBtnDefaults;
  @include font(12px, $black-color1, 600);
  border: 2px solid $black-color1;
  border-radius: 28px;
  text-align: center;
  line-height: 15px;
  max-width: 150px;
  width: 100%;
  text-transform: uppercase;
  padding: 10.5px 15px;
  &:hover {
    background: $black-color1;
    color: $white-color2;
  }
  &[disabled] {
    cursor: not-allowed;
    color: $grey-color2;
    border-color: $grey-color2;
    &:hover {
      background: $white-color2;
      color: $grey-color2;
    }
  }
  &_red {
    color: $red-color3;
    border-color: $red-color3;
    &:hover {
      background: $red-color3;
      color: $white-color2;
    }
  }
  &_white {
    color: $white-color2;
    border-color: $white-color2;
    background-color: transparent;
    &:hover {
      background: $white-color2;
      color: $red-color3;
    }
  }
  &_large {
    max-width: 180px;
  }
  &_align-left {
    text-align: left;
    .icon-base,
    svg {
      float: right;
      margin-right: 5px;
      margin-top: 2px;
    }
  }
  &_align-right {
    text-align: right;
  }
}

.tarriff-will-be-changed__btn[disabled] {
  &:hover {
    background: transparent;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/uikit/ButtonEl.vue